// extracted by mini-css-extract-plugin
export default {"transparent_btn":"styles_transparent_btn__Snykf"};